import React from 'react';
import {NavigationContainer} from "@react-navigation/native";
import Account from "./account";
import {createDrawerNavigator} from "@react-navigation/drawer";
import {createNativeStackNavigator} from "@react-navigation/native-stack";
import Shop from "./shop";
import Menu from "./menu";
import Search from "./search";
import Checkout from "./checkout";
import Ordered from "./ordered";
import Cart from "./cart";
import Splash from "./splash";
import Thankyou from "./thankyou";
import OrderReview from "./OrderReview";
import {InteractionManager} from "react-native";
import CartView from "./cart";

function ShopStack() {
    const Stack = createNativeStackNavigator();

    const transparentModalOptions = {
        headerShown: false,
        cardStyle: { backgroundColor: "#555", opacity: 0.5 },
        cardOverlayEnabled: true,
    };

    return (
        <Stack.Navigator screenOptions={{ animation: "fade" }}>
            <Stack.Group>
                <Stack.Screen name="Shop" component={Shop} options={{headerShown: false}}/>
                <Stack.Screen name="Menu" component={Menu} options={{headerShown: false, presentation: "transparentModal", animation: "fade"}} />
                <Stack.Screen name="Search" component={Search} options={{ headerShown: false, presentation: "transparentModal", animation: "fade" }} />
                <Stack.Screen name="Checkout" component={Checkout} options={{headerShown: false}} />
                <Stack.Screen name="Ordered" component={Ordered} options={{headerShown: false}} />
                <Stack.Screen name="OrderReview" component={OrderReview} options={{headerShown: false}} />
                <Stack.Screen name="Thankyou" component={Thankyou} options={{headerShown: false}} />
            </Stack.Group>
            <Stack.Group screenOptions={{ presentation: "transparentModal", animation: "fade" }}>
                <Stack.Screen name="Cart" component={CartView}
                              options={transparentModalOptions} />
            </Stack.Group>
        </Stack.Navigator>
    );
}

function AppStack() {
    const Drawer = createDrawerNavigator();

    // B6a: 헤더 좌측 햄버거(openDrawer) 제거로 이 드로어(Home+Account)는 은퇴.
    // 엣지 스와이프로도 열리지 않도록 swipeEnabled=false. 구조는 유지(네비게이션 리스크 회피).
    return (
        <Drawer.Navigator useLegacyImplementation={true} screenOptions={{swipeEnabled: false}}>
            <Drawer.Screen name="Home" component={ShopStack} options={{headerShown: false}}/>
            <Drawer.Screen name="Account" component={Account} options={{headerShown: false}}/>
        </Drawer.Navigator>
    );
}

function SplashStack() {
    const Stack = createNativeStackNavigator();

    return (
        <NavigationContainer
            documentTitle={{
                formatter: (options, route) => "Pikashop"
            }}
        >
            <Stack.Navigator screenOptions={{
                headerTitleAlign: "center",
                animation: "none",
            }}>
                <Stack.Screen name="Splash" component={Splash} options={{headerShown: false}}/>
                <Stack.Screen name="AppStack" component={AppStack} options={{headerShown: false}}/>
            </Stack.Navigator>
        </NavigationContainer>
    );
}

export default SplashStack;
